export default "<div id=\"chart\" echarts [options]=\"pricesChart\" class=\"demo-chart\"></div>";